
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref
} from 'vue'
import _ from 'lodash'
import { AreaChart } from '@carbon/charts'

import { useAxisChart } from '@/composables/useChart'
import { AreaChartOptions } from '@carbon/charts/interfaces'
import { AxisChart } from '@carbon/charts/axis-chart'
// import useDiagram from '@/composables/useDiagram'

interface ChartData {
  [key: string]: string | number | boolean
}

const DEFAULT_CONFIG = {
  title: '',
  axes: {
    left: {
      mapsTo: 'value',
      scaleType: 'linear',
    },
    bottom: {
      scaleType: 'time',
      mapsTo: 'date'
    }
  },
  curve: 'curveMonotoneX',
  // width: '600px',
  height: '300px'
}

export default defineComponent({
  name: 'AreaChart',
  components: {},
  props: {
    payload: {
      type: Array as PropType<Array<ChartData>>,
      default: (): Array<ChartData> => [{}]
    },
    config: {
      type: Object as PropType<AreaChartOptions>,
      default: () => DEFAULT_CONFIG
    }
  },
  setup (props) {

    const {
      chart,
      options,
      data,
      dom_container,
      update
    } = useAxisChart<AreaChartOptions, typeof AreaChart>(props, AreaChart)

    return {

      dom_container,
      options, data, chart,
    }
  }
})
